import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as o } from "../chunks/tslib.es6.js";
import { aliasOf as t } from "../core/accessorSupport/decorators/aliasOf.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { property as s } from "../core/accessorSupport/decorators/property.js";
import { subclass as e } from "../core/accessorSupport/decorators/subclass.js";
import i from "./Widget.js";
import "./support/widgetUtils.js";
import { messageBundle as r } from "./support/decorators/messageBundle.js";
import "../core/Logger.js";
import { tsx as n } from "./support/jsxFactory.js";
import a from "./Zoom/IconButton.js";
import m from "./Zoom/ZoomViewModel.js";
var l = {
  base: "esri-zoom esri-widget",
  horizontalLayout: "esri-zoom--horizontal",
  zoomInIcon: "esri-icon-plus",
  zoomOutIcon: "esri-icon-minus",
  widgetIcon: "esri-icon-zoom-in-magnifying-glass"
};

var u = /*#__PURE__*/function (_i) {
  _inherits(u, _i);

  var _super = _createSuper(u);

  function u(o, t) {
    var _this;

    _classCallCheck(this, u);

    _this = _super.call(this, o, t), _this.iconClass = l.widgetIcon, _this.label = void 0, _this.messages = null, _this.view = null, _this.viewModel = new m();
    return _this;
  }

  _createClass(u, [{
    key: "initialize",
    value: function initialize() {
      this._zoomInButton = new a({
        action: this.zoomIn.bind(this),
        iconClass: l.zoomInIcon
      }), this._zoomOutButton = new a({
        action: this.zoomOut.bind(this),
        iconClass: l.zoomOutIcon
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._zoomInButton.destroy(), this._zoomOutButton.destroy(), this._zoomInButton = null, this._zoomOutButton = null;
    }
  }, {
    key: "layout",
    set: function set(o) {
      "horizontal" !== o && (o = "vertical"), this._set("layout", o);
    }
  }, {
    key: "render",
    value: function render() {
      var o = this.viewModel,
          t = _defineProperty({}, l.horizontalLayout, "horizontal" === this.layout);

      return this._zoomInButton.enabled = "ready" === o.state && o.canZoomIn, this._zoomOutButton.enabled = "ready" === o.state && o.canZoomOut, this._zoomInButton.title = this.messages.zoomIn, this._zoomOutButton.title = this.messages.zoomOut, n("div", {
        class: this.classes(l.base, t)
      }, this._zoomInButton.render(), this._zoomOutButton.render());
    }
  }, {
    key: "zoomIn",
    value: function zoomIn() {
      return this.viewModel.zoomIn();
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      return this.viewModel.zoomOut();
    }
  }]);

  return u;
}(i);

o([s()], u.prototype, "iconClass", void 0), o([s({
  aliasOf: {
    source: "messages.widgetLabel",
    overridable: !0
  }
})], u.prototype, "label", void 0), o([s({
  value: "vertical"
})], u.prototype, "layout", null), o([s(), r("esri/widgets/Zoom/t9n/Zoom")], u.prototype, "messages", void 0), o([t("viewModel.view")], u.prototype, "view", void 0), o([s({
  type: m
})], u.prototype, "viewModel", void 0), u = o([e("esri.widgets.Zoom")], u);
var c = u;
export { c as default };